import { PayByZelleButton } from "@/components/zelle/ZellePay";
import { QrCode } from "lucide-react";
import { money } from "@/lib/landingSim";

const B = process.env.REACT_APP_BACKEND_URL;

export const PayOptions = ({ token, inv, zelle, due }) => (
  <div className={`mt-8 grid gap-4 ${zelle ? "sm:grid-cols-2" : ""}`} data-testid="invoice-pay-options">
    <div className="flex items-center gap-4 border border-slate-200 rounded-lg p-4 bg-slate-50 break-inside-avoid">
      <img src={`${B}/api/webadvisor/public/invoice/${token}/qr.png`} alt="Scan to view and pay" className="w-28 h-28 shrink-0 bg-white rounded" data-testid="invoice-qr" />
      <div className="text-sm">
        <p className="font-bold text-slate-900 flex items-center gap-1.5"><QrCode className="w-4 h-4 text-blue-600" />Scan to view &amp; pay</p>
        <p className="text-slate-600">Opens this invoice on your phone{due ? <> — <b>{money(due)}</b> due now</> : ""}. Pay securely by card in seconds.</p>
      </div>
    </div>
    {zelle && (
      <div className="flex items-center gap-4 border border-violet-200 rounded-lg p-4 bg-violet-50 break-inside-avoid" data-testid="invoice-zelle">
        {zelle.has_qr && <img src={`${B}/api/public/zelle-qr.png?v=${zelle.updated_at || ""}`} alt="Zelle QR" className="w-28 h-28 shrink-0 bg-white rounded object-contain" data-testid="invoice-zelle-qr" />}
        <div className="text-sm">
          <p className="font-bold text-violet-700">Fast checkout with Zelle</p>
          <p className="text-slate-700">Send <b data-testid="invoice-zelle-amount">{money(zelle.amount ?? due)}</b>{zelle.recipient_name || zelle.recipient_contact ? " to" : ""}</p>
          {zelle.recipient_name && <p className="font-semibold text-slate-900" data-testid="invoice-zelle-name">{zelle.recipient_name}</p>}
          {zelle.recipient_contact && <p className="text-slate-700 break-all" data-testid="invoice-zelle-contact">{zelle.recipient_contact}</p>}
          <p className="text-slate-600 mt-1">Memo: <b data-testid="invoice-zelle-memo">{zelle.memo}</b></p>
          <PayByZelleButton amount={zelle.amount ?? due} memo={zelle.memo} className="mt-2 print:hidden" />
          {zelle.instructions && <p className="text-xs text-slate-500 mt-1">{zelle.instructions}</p>}
        </div>
      </div>
    )}
  </div>
);
